// test1482
(1482 && 0);
